import axios from "axios";
import config from "../../config/Config";
import helper from "../../helpers/helper";

const { crmUserLoginURL } = config;

const action = {
  getLoginAuth: async function (payload, getAuthDetails, getLoginError) {
    const requestData = {
      method: "POST",
      url: crmUserLoginURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getAuthDetails(response?.data);
      })
      .catch((error) => {
        getLoginError(error?.response);
        console.error(error);
      });
  },
};
export default action;
